import {VehicleSelectionOutcomeOperator} from '@dms/api/sales';
import i18n from '@dms/i18n';

const OPERATOR_LABEL_KEYS: Record<VehicleSelectionOutcomeOperator, string> = {
  INCLUDED_IN: 'entity.promoPhotos.preview.operators.includedIn',
  EXCLUDED_FROM: 'entity.promoPhotos.preview.operators.excludedFrom',
  BETWEEN: 'entity.promoPhotos.preview.operators.between',
  GREATER_THAN: 'entity.promoPhotos.preview.operators.greaterThan',
  ON_OR_AFTER: 'entity.promoPhotos.preview.operators.onOrAfter',
  MISSING: 'entity.promoPhotos.preview.operators.missing',
};

export const getVehicleSelectionOperatorLabel = (operator: VehicleSelectionOutcomeOperator) =>
  i18n.t(OPERATOR_LABEL_KEYS[operator]);
